import {FreightTypeEntity} from "@ots-frontend/ots-data";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";
import {useCallback, useEffect, useState} from "react";

export type BaseFreightTypeMultiSelectProps = Omit<BaseEntityMultiSelectProps<FreightTypeEntity>, 'nameMapper'> & {
  useAbbreviation?: boolean;
};

export const BaseFreightTypeMultiSelect = (props: BaseFreightTypeMultiSelectProps) => {
  const {useAbbreviation = true, entities, ...rest} = props;

  const [sortedData, setSortedData] = useState(entities);

  // name mapper
  const nameMapper = useCallback(
    (e: FreightTypeEntity) => {
      if (useAbbreviation) {
        return e.abbr ?? e.name;
      } else {
        return e.name;
      }
    },
    [useAbbreviation]
  );

  // sort freight types by display name
  useEffect(() => {
    const sortedFreightTypes = entities.sort((a, b) =>
      nameMapper(a).localeCompare(nameMapper(b))
    );
    setSortedData(sortedFreightTypes);
  }, [entities, nameMapper]);

  return <BaseEntityMultiSelect entities={sortedData} nameMapper={nameMapper} {...rest} />;
};
